import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { View } from 'react-native';

import ListView from '../list-view';
import ExpandableListRow from './expandable-list-row';

import styles from './expandable-list-view.styles';

const noOp = () => {};

export default class ExpandableListView extends PureComponent {
  static propTypes = {
    state: PropTypes.shape({
      expandedItem: PropTypes.string,
      setExpandedItem: PropTypes.func,
      setExpandedItemOffset: PropTypes.func,
    }),
    rows: ListView.propTypes.rows,
    detailsGroups: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      key: PropTypes.string,
    }))),
    labels: PropTypes.object,
    renderRow: PropTypes.func,
    renderRowExpanded: PropTypes.func,
    renderRowExpandedLandscape: PropTypes.func,
    rowMarkerStyle: ListView.Row.propTypes.markerStyle,
    testID: PropTypes.string,
    removeClippedSubviews: PropTypes.bool,
    rememberState: PropTypes.bool,
    footer: PropTypes.node,
  };

  static defaultProps = {
    state: {
      expandedItem: null,
      setExpandedItem: noOp,
      setExpandedItemOffset: noOp,
    },
    rows: [],
    detailsGroups: [],
    labels: {},
    renderRow: noOp,
    renderRowExpanded: noOp,
    rowMarkerStyle: {
      fill: 'transparent',
    },
    testID: 'expandable-list-view',
    removeClippedSubviews: true,
    rememberState: false,
  };

  constructor(...args) {
    super(...args);

    this.rowHeight = null;
    this.state = {
      expandedItem: null,
    };

    this.renderComposedRow = this.renderComposedRow.bind(this);
    this.handleLayoutChange = this.handleLayoutChange.bind(this);
  }

  handleLayoutChange({ nativeEvent: { layout } }) {
    // set row height to be the min height of all rows
    if (this.rowHeight === null || layout.height < this.rowHeight) {
      this.rowHeight = layout.height;
    }
  }

  handlePressRow(rowId, isExpanded) {
    const {
      setExpandedItem,
      setExpandedItemOffset,
    } = this.props.state;

    if (this.props.rememberState) {
      setExpandedItem(isExpanded ? null : rowId);
    } else {
      this.setState({ expandedItem: isExpanded ? null : rowId });
    }

    if (!isExpanded) {
      const elementOffset = rowId * this.rowHeight;
      setExpandedItemOffset(elementOffset);
    } else {
      setExpandedItemOffset(null);
    }
  }

  renderComposedRow(row, sectionId, rowId) {
    const {
      state,
      renderRow,
      renderRowExpanded,
      rowMarkerStyle,
      rememberState,
      messages,
    } = this.props;

    let isExpanded = false;
    if (rememberState) {
      isExpanded = state.expandedItem === rowId;
    } else {
      isExpanded = this.state.expandedItem === rowId;
    }

    return (
      <ListView.Row onLayout={this.handleLayoutChange} markerStyle={rowMarkerStyle}>
        <ExpandableListRow
          canExpand={row.canExpand}
          expanded={isExpanded}
          onPress={() => this.handlePressRow(rowId, isExpanded)}
          expandedContent={renderRowExpanded(row)}
          messages={messages}
        >
          {renderRow(row)}
        </ExpandableListRow>
      </ListView.Row>
    );
  }

  render() {
    const {
      rows,
      testID,
      removeClippedSubviews,
      footer,
    } = this.props;

    const footerVisible = footer !== null;

    return (
      <div testID={testID}>
        <ListView
          rows={rows}
          testID="list"
          renderRow={this.renderComposedRow}
          removeClippedSubviews={removeClippedSubviews}
        />
        {footerVisible && footer}
      </div>
    );
  }
}
